export function normalizeLanguage(language) {
    if (!language || typeof language !== 'string') {
        return 'en';
    }

    return language.toLowerCase().split(/[-_]/)[0] === 'es' ? 'es' : 'en';
}

export function getStoredLanguage() {
    return normalizeLanguage(localStorage.getItem('lang'));
}

export function getBrowserLanguage() {
    return normalizeLanguage(navigator.language);
}

export function getCurrentLanguage(preferredLanguage) {
    if (preferredLanguage) {
        return normalizeLanguage(preferredLanguage);
    }

    const storedLanguage = localStorage.getItem('lang');

    if (storedLanguage) {
        return normalizeLanguage(storedLanguage);
    }

    return getBrowserLanguage();
}
